import * as fromDatatype from '../datatype-library/index';

export interface bl_crm_contact_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  key_guid: fromDatatype.GuidDataFieldInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  first_name: fromDatatype.VarcharDatatypeInterface;
  last_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  blocked: boolean;
}

export class bl_crm_contact_hdr_RowClass
  implements bl_crm_contact_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  key_guid: fromDatatype.GuidDataFieldInterface;
  source_guid: fromDatatype.GuidDataFieldInterface;
  name: fromDatatype.VarcharDatatypeInterface;
  first_name: fromDatatype.VarcharDatatypeInterface;
  last_name: fromDatatype.VarcharDatatypeInterface;
  description: fromDatatype.TextDatatypeInterface;
  id_no: fromDatatype.VarcharDatatypeInterface;
  id_type: fromDatatype.VarcharDatatypeInterface;
  phone: fromDatatype.VarcharDatatypeInterface;
  email: fromDatatype.VarcharDatatypeInterface;
  ref_1: fromDatatype.VarcharDatatypeInterface;
  ref_2: fromDatatype.VarcharDatatypeInterface;
  ref_3: fromDatatype.VarcharDatatypeInterface;
  ref_4: fromDatatype.VarcharDatatypeInterface;
  ref_5: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  blocked: boolean;
}
